import { RadioGroup } from 'radix-ui'
import { useTranslation } from 'react-i18next'
import type { Portal } from '../types'
import { useGuardians } from '../guardians'
import { portalsFor } from '../portals'
import { cn } from '@/utils/cn'

/** Segmented control for choosing which workspace to sign in to. */
export function PortalSwitcher({ value, onChange }: { value: Portal; onChange: (portal: Portal) => void }) {
  const { t } = useTranslation('auth')
  const guardians = useGuardians()
  return (
    <RadioGroup.Root
      value={value}
      onValueChange={(v) => onChange(v as Portal)}
      aria-label={t('Choose your portal')}
      className="grid grid-cols-3 gap-1 rounded-xl border border-line bg-surface-sunken p-1"
    >
      {portalsFor(guardians).map(({ key, short, icon: Icon }) => (
        <RadioGroup.Item
          key={key}
          value={key}
          className={cn(
            'flex min-w-0 flex-col items-center justify-center gap-1 rounded-[0.55rem] px-1 py-2 text-center text-xs leading-tight font-medium text-muted transition-all hover:text-ink min-[360px]:flex-row min-[360px]:gap-1.5 min-[360px]:px-2',
            'data-[state=checked]:bg-surface data-[state=checked]:text-brand-700 data-[state=checked]:shadow-card',
          )}
        >
          <Icon className="size-4 shrink-0" aria-hidden="true" />
          <span className="min-w-0">{t(short)}</span>
        </RadioGroup.Item>
      ))}
    </RadioGroup.Root>
  )
}
